// extracted by mini-css-extract-plugin
module.exports = {"messageList":"styles_messageList__13Cbg","mobileMessageList":"styles_mobileMessageList__2U04N"};